import checkbox from '../../../../../assets/template-icons/checkbox.svg';
import dateTime from '../../../../../assets/template-icons/date-time.svg';
import date from '../../../../../assets/template-icons/date.svg';
import decimals from '../../../../../assets/template-icons/decimals.svg';
import dropdown from '../../../../../assets/template-icons/dropdown.svg';
import list from '../../../../../assets/template-icons/list.svg';
import duration from '../../../../../assets/template-icons/duration.svg';
import file from '../../../../../assets/template-icons/file.svg';
import integer from '../../../../../assets/template-icons/integer.svg';
import location from '../../../../../assets/template-icons/location.svg';
import multiline from '../../../../../assets/template-icons/multiline.svg';
import multimedia from '../../../../../assets/template-icons/multimedia.svg';
import picture from '../../../../../assets/template-icons/picture.svg';
import signature from '../../../../../assets/template-icons/signature.svg';
import singleLine from '../../../../../assets/template-icons/single-line.svg';
import textBlock from '../../../../../assets/template-icons/text-block.svg';
import attachPdf from '../../../../../assets/template-icons/attach-pdf.svg';
import draw from '../../../../../assets/template-icons/draw.svg';
import formula from '../../../../../assets/template-icons/formula.svg';
import pictureInTemplate from '../../../../../assets/template-icons/picture-in-template.svg';
import multipleCheckboxes from '../../../../../assets/template-icons/multiple-checkboxes.svg';
import qr from '../../../../../assets/template-icons/qr.svg';
import barCode from '../../../../../assets/template-icons/bar-code.svg';
import radio from '../../../../../assets/template-icons/radio.svg';
import pageBreak from '../../../../../assets/template-icons/page-break.svg';
import emptySpace from '../../../../../assets/template-icons/space-icon.png';

import { ENTRY_TYPES } from '../../../../../../../../constants';

export default {
  [ENTRY_TYPES.TEXT]: singleLine,
  [ENTRY_TYPES.MULTILINE_TEXT]: multiline,
  [ENTRY_TYPES.INT]: integer,
  [ENTRY_TYPES.DECIMAL]: decimals,
  [ENTRY_TYPES.FILE]: file,
  [ENTRY_TYPES.PICTURE_IN_TEMPLATE]: pictureInTemplate,
  [ENTRY_TYPES.PDF_ATTACHMENT]: attachPdf,
  [ENTRY_TYPES.PHOTO]: picture,
  [ENTRY_TYPES.FEED]: multimedia,
  [ENTRY_TYPES.RADIO_BUTTON]: radio,
  [ENTRY_TYPES.CHECKBOX]: checkbox,
  [ENTRY_TYPES.MULTIPLE_CHECKBOXES]: multipleCheckboxes,
  [ENTRY_TYPES.DROPDOWN]: dropdown,
  [ENTRY_TYPES.TEXT_BLOCK]: textBlock,
  [ENTRY_TYPES.LOCATION]: location,
  [ENTRY_TYPES.DATE]: date,
  [ENTRY_TYPES.DATE_TIME]: dateTime,
  [ENTRY_TYPES.TIME]: duration,
  [ENTRY_TYPES.LIST]: list,
  [ENTRY_TYPES.SIGNATURE]: signature,
  [ENTRY_TYPES.DRAWING]: draw,
  [ENTRY_TYPES.FORMULA]: formula,
  [ENTRY_TYPES.QR_CODE]: qr,
  [ENTRY_TYPES.BAR_CODE]: barCode,
  [ENTRY_TYPES.PAGE_BREAK]: pageBreak,
  [ENTRY_TYPES.EMPTY_SPACE]: emptySpace,
};
// { type: 'Drawing/Sketch', id: 16, icon: draw },
// { name: 'QR Code', id: 17, icon: qr },
// { name: 'Barcode', id: 18, icon: code }
